import { getMetaContent } from './meta';

/**
 * Build the share URL for a channel using the workspace subdomain
 * @param {Object} channel - Channel object with share_key property
 * @param {Object} workspace - Workspace object with slug property
 * @returns {string} The channel share URL
 */
export const buildChannelShareUrl = (workspace, channel) => {
  const host = getMetaContent('env:default_host');
  return `https://${workspace?.slug}.${host}/chat/${channel.share_key}`;
};

// Standard scope for all channels the current user can browse/search
export const BROWSABLE_CHANNEL_KINDS = ['public', 'open_breakout'];
export const isBrowsableChannel = (channel) => BROWSABLE_CHANNEL_KINDS.includes(channel?.kind);

export const getChannelDisplayName = (channel) => {
  if (!channel) return 'Untitled';
  return channel.name || 'Untitled';
};
